import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'

const NavNewBadge: React.FC = () => {
  const { t } = useLocale()

  return (
    <div
      className='flex h-4 shrink-0 items-center justify-center rounded-full px-1'
      style={{
        backgroundImage:
          'linear-gradient(114.521deg, rgba(0, 212, 146, 0.3) 1.9893%, rgba(0, 212, 146, 0.12) 104.59%)'
      }}
    >
      <span
        className='bg-clip-text px-0.5 text-text-xxs-bold uppercase leading-4 tracking-[0.4px] text-transparent'
        style={{
          backgroundImage: 'linear-gradient(111.57deg, rgb(24, 24, 27) 7.22%, rgb(0, 122, 85) 67.46%)'
        }}
      >
        {t('navigation.new_badge')}
      </span>
    </div>
  )
}

export default NavNewBadge
